import UserActivityTable from 'components/Admin/UsersActivity/components/UserActivityTable';
import React from 'react';

const ProfileUserActivity = () => {
	return <UserActivityTable />;
};

export default ProfileUserActivity;
